import { createStore } from "vuex";
import Flight from "@/models/FlightModel";
import Flights from "@/models/FlightsModels";
import Order from "@/models/OrderModel";
import Ticket from "@/models/TicketModel";
import allOrders from "@/models/allOrdersModel";
import axios from "axios";
import router from "../router/index";
import authModule from "./modules/auth";
import AllTickets from "@/models/AllTicketsModel";

const axioCred = axios.create({
  withCredentials: true,
});

export default createStore({
  state: {
    flights: [] as Flight[],
    orders: [] as allOrders[],
    tickets: [] as AllTickets[]
  },
  mutations: {
    FETCH_ORDERS(state, data): Order[] {
      return (state.orders = data);
    },
  },
  actions: {
    async fetchOrders({ commit }) {
      const api = "https://www.biletdv.ru/customer/IBEServices/GetUserOrders";
      try {
        const response = await axioCred.get(api);
        const data = await response.data;
        console.log(data);
        return commit("FETCH_ORDERS", data);
      } catch (error) {
        if (error) {
          if (error.response.status == 401) {
            sessionStorage.removeItem("user");
            router.push("/login");
          }
          console.log(error.response.status);
          return error.message;
        }
      }
    },
  },
  modules: {
    auth: authModule,
  },
  strict: true,
});
